import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

export default ({
	question,
	isBilateral
}) => {
	return (
		<div>
			<Grid
				data-testid="readonly-block"
				container
				direction='column'
				justify='flex-start'
				className="surveyDescription"
				style={{
					marginBottom: isBilateral ? "0" : undefined
				}}
			>
				<Grid item>
					<Typography
						data-testid="readonly-block-title"
						variant='subtitle1'
						style={{ fontSize: '18px', marginBottom: '16px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}
					>
						<span dangerouslySetInnerHTML={{ __html:question.subtitle }} />
					</Typography>
				</Grid>
				<Grid item>
					<Typography data-testid="readonly-block-body"
						variant='subtitle2' style={{ fontSize: '18px', fontWeight: '400', letterSpacing: '1px' }}
					>
						<span dangerouslySetInnerHTML={{ __html:question.bodyCopy }} />
					</Typography>
				</Grid>
			</Grid>
		</div>
	)
}
